<div class="h-100">
  <finxone-web-frontend-accounts-listing
    class="h-100"
    [widgetConfigData]="widgetConfig"
    [contentStyle]="contentStyle"
    [textContentStyle]="textContentStyle"
    [searchIconStyle]="searchIconStyle"
    [accountsInfo]="accountsInfo"
    [totalListCount]="totalListCount"
    [currencies]="currencies"
    [countries]="countries"
    (scrolled)="handleChildScroll()"
    [contextSwitch]="contextSwitch"
    [navigateToUrl]="navigateToUrl"
    (selectedAccountEmit)="updateFormSate($event)"
    [accountContextStatusList]="accountContextStatusList"
  ></finxone-web-frontend-accounts-listing>
</div>
